<template>
  <div>
    <table class='table is-striped is-fullwidth'>
      <thead>
        <tr>
          <th>Domain</th>
          <th>Block Type</th>
        </tr>
      </thead>

      <tbody>
        <tr
          v-for='entry in list'
          :key='entry.domain'
          style='cursor: pointer'
          @click='$emit("rowClicked", entry)'
        >
          <td>{{ entry.domain }}</td>
          <td>{{ entry.blockType }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'BlockedRecipientsList',

  props: {
    list: {
      type: Array,
      default: () => []
    }
  }
}
</script>